var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#C8DBF9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.334 27.167L30.8597 33.835C31.6311 34.375 32.0168 34.6449 32.4363 34.7495C32.8069 34.8419 33.1944 34.8419 33.565 34.7495C33.9845 34.6449 34.3702 34.375 35.1416 33.835L44.6673 27.167M26.934 42.3337H39.0673C41.0275 42.3337 42.0076 42.3337 42.7563 41.9522C43.4149 41.6166 43.9503 41.0812 44.2858 40.4226C44.6673 39.6739 44.6673 38.6938 44.6673 36.7337V29.267C44.6673 27.3068 44.6673 26.3267 44.2858 25.578C43.9503 24.9195 43.4149 24.384 42.7563 24.0485C42.0076 23.667 41.0275 23.667 39.0673 23.667H26.934C24.9738 23.667 23.9937 23.667 23.245 24.0485C22.5865 24.384 22.051 24.9195 21.7155 25.578C21.334 26.3267 21.334 27.3068 21.334 29.267V36.7337C21.334 38.6938 21.334 39.6739 21.7155 40.4226C22.051 41.0812 22.5865 41.6166 23.245 41.9522C23.9937 42.3337 24.9738 42.3337 26.934 42.3337Z",
    stroke: "#4773B5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#D7E7FF",
    strokeWidth: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailbox);
export default __webpack_public_path__ + "static/media/mailbox.b7d9a861248f47496c1b6d641029587a.svg";
export { ForwardRef as ReactComponent };